// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__XGVpf","empty":"ModalGraph_empty__17p3c"};